import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
  CircularProgress
} from "@material-ui/core";

import { useDispatch, useSelector } from "react-redux";
import { getLossSaleReasonList } from "../../store/actions/createUpdateEnquiry.actions";

interface Props {
  open: boolean;
  onSubmit: (data: any) => void;
  loading?: boolean;
}

const LeaveEnquiryPopup: React.FC<Props> = ({ open, onSubmit, loading: submitLoading }) => {

  const dispatch = useDispatch();
  const [error, setError] = useState(false);

  const createUpdateEnquiryState: any =
    useSelector((state: any) => state?.createUpdateEnquiry) || {};

  const getLossSalesReasonList = createUpdateEnquiryState?.getLossSalesReasonList || {};
  const reasonList = getLossSalesReasonList?.data || [];
  const loading = getLossSalesReasonList?.loading === true && reasonList.length === 0;

  const [selectedReasons, setSelectedReasons] = useState<number[]>([]);
  const [otherReason, setOtherReason] = useState("");

  useEffect(() => {
    if (open) {
      dispatch(getLossSaleReasonList());
      setSelectedReasons([]);
      setOtherReason("");
    }
  }, [open, dispatch]);

  const filteredReasons = reasonList.filter(
    (item: any) => item?.type?.toLowerCase().trim() !== "skip"
  );

  const handleReason = (e: React.ChangeEvent<HTMLInputElement>, reasonCode: number) => {
    if (e.target.checked) {
      setSelectedReasons(prev => [...prev, reasonCode]);
    } else {
      setSelectedReasons(prev => prev.filter(r => r !== reasonCode));
    }
  };

  const handleSubmit = () => {
    if (selectedReasons.includes(4) && !otherReason.trim()) {
      setError(true);
      return;
    }

    setError(false);
    onSubmit({
      reasons: selectedReasons,
      otherReason
    });
  };

  const handleSkip = () => {

    const skipReason = reasonList.find(
      (item: any) => item?.type?.toLowerCase().trim() === "skip"
    );

    onSubmit({
      reasons: skipReason ? [Number(skipReason.code)] : [4], // fallback 4
      otherReason: ""
    });
  };

  const isOtherSelected = filteredReasons.some(
    (item: any) =>
      selectedReasons.includes(Number(item.code)) &&
      item.type?.toLowerCase().includes("other")
  );

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 16,
          padding: "10px 5px"
        }
      }}
    >
      <DialogContent>

        <div style={{ display: "flex", alignItems: "flex-start", marginBottom: 20 }}>
          <div
            style={{
              background: "#2D9CDB",
              width: 45,
              height: 45,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: 15
            }}
          >
            <span style={{ color: "#fff", fontWeight: 700, fontSize: 20 }}>!</span>
          </div>

          <div>
            <div style={{ fontSize: 18, fontWeight: 600 }}>
              So close to ordering!
            </div>
            <div style={{ fontSize: 14, color: "#666", marginTop: 4 }}>
              Please tell us what stopped you from confirming the order?
            </div>
          </div>
        </div>

        {loading && (
          <div style={{ textAlign: "center", padding: 20 }}>
            <CircularProgress size={24} />
          </div>
        )}

        {!loading && (
          <FormGroup style={{ marginTop: 10 }}>
            {filteredReasons.map((item: any) => (
              <FormControlLabel
                key={item?.code}
                style={{ marginBottom: 10 }}
                control={
                  <Checkbox
                    checked={selectedReasons.includes(Number(item?.code))}
                    onChange={(e) => handleReason(e, Number(item?.code))}
                    style={{ color: "#2D9CDB" }}
                  />
                }
                label={<span style={{ fontSize: 14 }}>{item?.type}</span>}
              />
            ))}

            {isOtherSelected && (
              <TextField
                fullWidth
                multiline
                rows={3}
                inputProps={{ maxLength: 100 }}
                placeholder="Enter reason (Max 100 characters)*"
                value={otherReason}
                onChange={(e) => setOtherReason(e.target.value)}
                style={{ marginTop: 10 }}
                variant="outlined"
                error={error}
                helperText={error ? "Please tell us more about your reason here." : ""}
              />
            )}
          </FormGroup>
        )}

      </DialogContent>

      <DialogActions
        style={{
          justifyContent: "right",
          paddingBottom: 20,
          paddingRight: 50
        }}
      >
        <Button
          onClick={handleSubmit}
          disabled={selectedReasons.length === 0 || submitLoading}
          style={{
            backgroundColor: "#2D9CDB",
            color: "#fff",
            borderRadius: 25,
            padding: "8px 30px",
            textTransform: "none",
            fontWeight: 600,
            marginRight: 15,
            minWidth: 120
          }}
        >
          {submitLoading
            ? <CircularProgress size={20} style={{ color: "#fff" }} />
            : "Submit"}
        </Button>

        <Button
          onClick={handleSkip}
          disabled={submitLoading}
          style={{
            backgroundColor: "#E0E0E0",
            color: "#555",
            borderRadius: 25,
            padding: "8px 30px",
            textTransform: "none",
            fontWeight: 600
          }}
        >
          Skip
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeaveEnquiryPopup;